// lib/axiosConfig.ts
import axios from 'axios';

// export const baseURLApi = "https://darmanshirin.com/p/api";
// export const baseURL = "https://darmanshirin.com/p";
// export const baseDomain = "https://darmanshirin.com";

export const baseDomain = process.env.NEXT_PUBLIC_BASE_DOMAIN ?? '';
export const baseURL = process.env.NEXT_PUBLIC_BACKEND_URL ?? '';
export const staticURL = process.env.NEXT_PUBLIC_STATIC_URL ?? '';
export const baseURLApi = `${baseURL}/api`;
export const baseStaticURL = `${staticURL}/api`;

const axiosInstance = axios.create({
    baseURL: baseURLApi,
    // headers: {
    //   'Content-Type': 'application/json',
    // },
});
const axiosClientInstance = axios.create({
    baseURL: baseStaticURL,
    // headers: {
    //   'Content-Type': 'application/json',
    // },
});

export default axiosInstance;
export { axiosClientInstance };

// lib/axiosConfig.ts
// import axios from 'axios';

// export const baseURLApi = "http://127.0.0.1:8000/api";
// export const baseURL = "http://127.0.0.1:8000";
// export const baseDomain = "http://127.0.0.1:8000";

// const axiosInstance = axios.create({
//     baseURL: baseURLApi,
//     // headers: {
//     //   'Content-Type': 'application/json',
//     // },
// });

// export default axiosInstance;
